/**
 * Bundled translations.
 *
 * These are the machine-translated baseline (FR55a). A shop overrides any of
 * them from Admin and its wording wins — that resolution happens in
 * `createTranslator`, not here.
 *
 * English is the key set. A missing key falls back to English and then to the
 * key itself, so a new string never blanks a screen before it is translated.
 */

import type { Dictionary } from './i18n.js';

export const DICTIONARIES: Record<string, Dictionary> = {
  en: {
    Dashboard: 'Dashboard', Jobs: 'Jobs', Customers: 'Customers', Catalog: 'Catalog',
    Rates: 'Rates', Settings: 'Settings', Admin: 'Admin',
    Vehicle: 'Vehicle', Capture: 'Capture', Review: 'Review', Price: 'Price',
    Photos: 'Photos', Issue: 'Issue',
    Shop: 'Shop', 'This job': 'This job', Totals: 'Totals', Parts: 'Parts', Total: 'Total',
    Language: 'Language', 'Sign in': 'Sign in', 'Sign out': 'Sign out',
    Open: 'Open', 'Awaiting approval': 'Awaiting approval', Invoiced: 'Invoiced',
    Printed: 'Printed', 'Total loss': 'Total loss', Declined: 'Declined',
    'Needs approval': 'Needs approval', 'Auto-approve': 'Auto-approve',
    Refinish: 'Refinish', 'Panel beating': 'Panel beating', Estimate: 'Estimate',
    Invoice: 'Invoice', Customer: 'Customer',
  },
  ar: {
    Dashboard: 'لوحة المعلومات', Jobs: 'أوامر العمل', Customers: 'العملاء',
    Catalog: 'الكتالوج', Rates: 'الأسعار', Settings: 'الإعدادات', Admin: 'الإدارة',
    Vehicle: 'المركبة', Capture: 'التصوير', Review: 'المراجعة', Price: 'التسعير',
    Photos: 'الصور', Issue: 'الإصدار',
    Shop: 'الورشة', 'This job': 'هذا الأمر', Totals: 'الإجماليات', Parts: 'القطع',
    Total: 'الإجمالي', Language: 'اللغة', 'Sign in': 'تسجيل الدخول',
    'Sign out': 'تسجيل الخروج',
    Open: 'مفتوح', 'Awaiting approval': 'بانتظار الموافقة', Invoiced: 'تمت الفوترة',
    Printed: 'تمت الطباعة', 'Total loss': 'خسارة كلية', Declined: 'مرفوض',
    'Needs approval': 'يتطلب موافقة', 'Auto-approve': 'موافقة تلقائية',
    Refinish: 'إعادة التشطيب', 'Panel beating': 'ضرب اللوحة', Estimate: 'تقدير',
    Invoice: 'فاتورة', Customer: 'زبون',
  },
  fr: {
    Dashboard: 'Tableau de bord', Jobs: 'Dossiers', Customers: 'Clients',
    Catalog: 'Catalogue', Rates: 'Tarifs', Settings: 'Paramètres', Admin: 'Administration',
    Vehicle: 'Véhicule', Capture: 'Prise de vue', Review: 'Révision', Price: 'Tarification',
    Photos: 'Photos', Issue: 'Émission',
    Shop: 'Atelier', 'This job': 'Ce dossier', Totals: 'Totaux', Parts: 'Pièces',
    Total: 'Total', Language: 'Langue', 'Sign in': 'Se connecter',
    'Sign out': 'Se déconnecter',
    Open: 'Ouvert', 'Awaiting approval': "En attente d'accord", Invoiced: 'Facturé',
    Printed: 'Imprimé', 'Total loss': 'Perte totale', Declined: 'Refusé',
    'Needs approval': 'Accord requis', 'Auto-approve': 'Accord automatique',
    Refinish: 'Réfection', 'Panel beating': 'Débosselage', Estimate: 'Devis',
    Invoice: 'Facture', Customer: 'Client',
  },
  de: {
    Dashboard: 'Übersicht', Jobs: 'Aufträge', Customers: 'Kunden', Catalog: 'Katalog',
    Rates: 'Sätze', Settings: 'Einstellungen', Admin: 'Verwaltung',
    Vehicle: 'Fahrzeug', Capture: 'Aufnahme', Review: 'Prüfung', Price: 'Kalkulation',
    Photos: 'Fotos', Issue: 'Ausgabe',
    Shop: 'Werkstatt', 'This job': 'Dieser Auftrag', Totals: 'Summen', Parts: 'Teile',
    Total: 'Gesamt', Language: 'Sprache', 'Sign in': 'Anmelden', 'Sign out': 'Abmelden',
    Open: 'Offen', 'Awaiting approval': 'Freigabe ausstehend', Invoiced: 'Berechnet',
    Printed: 'Gedruckt', 'Total loss': 'Totalschaden', Declined: 'Abgelehnt',
    'Needs approval': 'Freigabe nötig', 'Auto-approve': 'Auto-Freigabe',
    Refinish: 'Lackierung', 'Panel beating': 'Ausbeulen', Estimate: 'Kostenvoranschlag',
    Invoice: 'Rechnung', Customer: 'Kunde',
  },
  nb: {
    Dashboard: 'Oversikt', Jobs: 'Oppdrag', Customers: 'Kunder', Catalog: 'Katalog',
    Rates: 'Satser', Settings: 'Innstillinger', Admin: 'Administrasjon',
    Vehicle: 'Kjøretøy', Capture: 'Bilder', Review: 'Gjennomgang', Price: 'Prising',
    Photos: 'Bilder', Issue: 'Utstedelse',
    Shop: 'Verksted', 'This job': 'Dette oppdraget', Totals: 'Totaler', Parts: 'Deler',
    Total: 'Totalt', Language: 'Språk', 'Sign in': 'Logg inn', 'Sign out': 'Logg ut',
    Open: 'Åpen', 'Awaiting approval': 'Venter på godkjenning', Invoiced: 'Fakturert',
    Printed: 'Utskrevet', 'Total loss': 'Kondemnert', Declined: 'Avslått',
    'Needs approval': 'Krever godkjenning', 'Auto-approve': 'Auto-godkjenn',
    Refinish: 'Lakkering', 'Panel beating': 'Oppretting', Estimate: 'Kalkyle',
    Invoice: 'Faktura', Customer: 'Kunde',
  },
};
